import { connect } from 'react-redux'
import MoshaveranUI from './MoshaveranUI'
import { Dispatch } from 'redux';
import ApplicationState from '../../../../../../../ApplicationState';
import MoshaveranState from '../../State/MoshaveranState';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import { MoshaveranDispatch } from './model';
import { actionFetchMoshaveran } from '../../Actions/ActionCreator';



const mapStateToProps = (state: ApplicationState): IState<MoshaveranState> => {
    return {
        state: state.moshaveran
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<MoshaveranDispatch> => ({
    dispatcher: {
        fetchMoshaveranList: () => { dispatch(actionFetchMoshaveran() as any) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(MoshaveranUI)